export default [
    "15 15",
    '<path d="M3.125 7.5H11.875"  fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]

